const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));
export const fetchWithRetry = async (url, options, retries = 3, baseDelay = 500) => {
    for (let attempt = 0; attempt <= retries; attempt++) {
        try {
            const response = await fetch(url, options);
            const shouldRetry = [500, 502, 503, 504].includes(response.status);
            if (response.ok || !shouldRetry || attempt === retries) {
                return response;
            }
        }
        catch (error) {
            if (attempt === retries) {
                throw error;
            }
        }
        const delay = baseDelay * Math.pow(2, attempt);
        await sleep(delay);
    }
    throw new Error('Fetch failed after retries');
};
